/**
 * 常用工具方法
 */

const util = {};

// 等比例缩放
util.initPageSize = (sourceWidth, sourceHeight, needScale) => {

  let app = document.getElementById("app");
  const scaleWidthPercent = document.documentElement.clientWidth / sourceWidth;
  const scaleHeightPercent = document.documentElement.clientHeight /
    sourceHeight;

  app.style.width = sourceWidth + "px";
  app.style.height = sourceHeight + "px";

  if (needScale) {
    app.style.transform = "scale(" +
      Math.min(scaleWidthPercent, scaleHeightPercent) + ")";
  }
};

// series自动高亮
util.autoHighlightBar = (chart, dataCount, series, timer, isInit) => {
  let activeIndex = 0;

  if (isInit) {
    chart.dispatchAction({
      type: "highlight",
      seriesIndex: series,
      dataIndex: 0,
    });

    chart.dispatchAction({
      type: "showTip",
      seriesIndex: series,
      dataIndex: 0,
    });
  }

  if (timer) {
    clearInterval(timer);
  }

  timer = setInterval(() => {
    if (activeIndex < dataCount - 1) {
      activeIndex = activeIndex + 1;
    } else {
      activeIndex = 0;
    }

    chart.dispatchAction({
      type: "downplay",
      seriesIndex: series,
    });

    chart.dispatchAction({
      type: "hideTips",
      seriesIndex: series,
    });

    chart.dispatchAction({
      type: "highlight",
      seriesIndex: series,
      dataIndex: activeIndex,
    });

    chart.dispatchAction({
      type: "showTip",
      seriesIndex: series,
      dataIndex: activeIndex,
    });
  }, 4000);

  return timer;
};

/**
 * 修改集合的key
 * matchKey: [{old: 'a', new: 'b'}]
 * */
util.convertKey = (arr, matchKey) => {
  let resultArr = [];

  arr.forEach(function (item) {
    let newItem = {};

    matchKey.forEach((key) => {
      newItem[key.new] = item[key.old];
    });

    resultArr.push(newItem);
  });

  return resultArr;
};

/**
 * get参数处理
 * */
util.urlParams = params => {

  if (!params) {
    return "";
  }

  let paramArr = Object.keys(params).reduce((acc, cur) => {
    acc.push(cur + "=" + params[cur]);
    return acc;
  }, []);
  return paramArr.join("&");
};

util.linkWrapUrl = url => {
  location.href = url;
};

/**
 * 数字转中文
 * */
util.convertNumToChinese = num => {
  const arr1 = ["天", "一", "二", "三", "四", "五", "六", "七", "八", "九"];

  const arr2 = ["", "十", "百", "千", "万", "十", "百", "千", "亿", "十", "百", "千", "万", "十", "百", "千", "亿"];//可继续追加更高位转换值

  if (!num || isNaN(num)) {

    return "零";

  }

  let english = num.toString().split("");

  let result = "";

  for (let i = 0; i < english.length; i++) {
    let des_i = english.length - 1 - i;//倒序排列设值
    result = arr2[i] + result;
    let arr1_index = english[des_i];
    result = arr1[arr1_index] + result;
  }
  //将【零千、零百】换成【零】 【十零】换成【十】
  result = result.replace(/零(千|百|十)/g, "零").replace(/十零/g, "十");
  //合并中间多个零为一个零
  result = result.replace(/零+/g, "零");
  //将【零亿】换成【亿】【零万】换成【万】
  result = result.replace(/零亿/g, "亿").replace(/零万/g, "万");
  //将【亿万】换成【亿】
  result = result.replace(/亿万/g, "亿");
  //移除末尾的零
  result = result.replace(/零+$/, "");
  //将【零一十】换成【零十】
  //result = result.replace(/零一十/g, '零十');
  //貌似正规读法是零一十
  //将【一十】换成【十】
  result = result.replace(/^一十/g, "十");

  return result;
};

util.formatInt = (num, prec = 2, ceil = true) => {
  const len = String(num).length;
  if (len <= prec) {
    return num;
  }
  const mult = Math.pow(10, prec);
  return ceil ?
    Math.ceil(num / mult) * mult :
    Math.floor(num / mult) * mult;
};

util.padStartInt = (val, length) => {
  if (typeof val === "number") {
    val = val.toString();
  }
  if (val.length < length) {
    val = val.padStart(length, "0");
  }
  return val;
};
export default util;
